import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Card, CardContent, Grid } from "@material-ui/core";
import Order from "../../../actions/order";
import Loading from "../../../components/customHelpers/Loading";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import Notify from "../../../components/customHelpers/Notify";
import { useHistory } from "react-router-dom";
import Popup from "../../../components/customHelpers/Popup";
import CustomerOrderPage from "../../../components/forms/allOrdersForCustomer";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[2],
    minWidth: "90%",
  },
  tableContainer: {
    maxHeight: 200,
    overflow: "auto",
    "&::-webkit-scrollbar": {
      width: "8px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.palette.grey[400],
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
    scrollbarWidth: "thin",
    scrollbarColor: `${theme.palette.grey[400]} transparent`,
  },
}));

const CustomerOrder = ({ id }) => {
  const history = useHistory();
  const [orders, setOrders] = useState([]);
  const { NotifyMessage } = Notify();
  const { viewCustomerOrders } = Order();
  const classes = useStyles();
  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  const [totals, setTotals] = useState({
    totalPaid: 0,
    totalUnpaid: 0,
  });
  const { loading, reload } = values;

  useEffect(() => {
    getAllOrders();
  }, [id]);

  const getAllOrders = () => {
    setValues({ ...values, loading: true });
    viewCustomerOrders(id).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.orders) {
        setValues({
          ...values,
          loading: false,
        });

        const filteredOrders = data.orders.filter(
          (order) => order.status !== "Pending"
        );

        setOrders(filteredOrders);
        let totalPaid = 0;
        let totalUnpaid = 0;

        filteredOrders.forEach((order) => {
          const orderPaid = parseFloat(order.paid) || 0;
          const totalOrderPrice =
            order.orderProducts?.reduce(
              (sum, product) => sum + (parseFloat(product.totalPrice) || 0),
              0
            ) || 0;

          totalPaid += orderPaid;
          totalUnpaid += totalOrderPrice - orderPaid;
        });

        setTotals({
          totalPaid: totalPaid.toFixed(2),
          totalUnpaid: totalUnpaid.toFixed(2),
        });
      }
    });
  };
  const calculateTotalPrice = (data) => {
    let totalPrice = 0;
    if (data.length > 0) {
      data.forEach((order) => {
        totalPrice += parseFloat(order.totalPrice);
      });
      return totalPrice.toFixed(2);
    }
  };
  const [openPopup, setOpenPopup] = useState(false);

  return (
    <>
      <Card className={classes.root}>
        <CardContent>
          <Grid item xs={12}>
            {loading ? (
              <Loading />
            ) : (
              <div className={classes.tableContainer}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ padding: "4px" }}>ID</TableCell>
                      <TableCell sx={{ padding: "4px" }}>Assigned To</TableCell>
                      <TableCell sx={{ padding: "4px" }}>Total Price</TableCell>
                      <TableCell sx={{ padding: "4px" }}>Paid</TableCell>
                      <TableCell sx={{ padding: "4px" }}>Unpaid</TableCell>
                      <TableCell sx={{ padding: "4px" }}>Status</TableCell>
                      <TableCell sx={{ padding: "4px" }}>Date</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {orders.length > 0 ? (
                      orders.slice(0, 5).map((row) => (
                        <TableRow key={row.id}>
                            <TableCell>{row.orderId?row.orderId:`${row.id.slice(0, 7)}--`}</TableCell>
                            <TableCell>{row.staff?.fullName}</TableCell>
                          <TableCell>
                            {row?.orderProducts?.length > 0
                              ? calculateTotalPrice(row.orderProducts)
                              : 0}
                          </TableCell>
                          <TableCell>{row.paid}</TableCell>
                          <TableCell>
                            {calculateTotalPrice(row.orderProducts) - row.paid}
                          </TableCell>
                          <TableCell>{row.status}</TableCell>
                          <TableCell>
                            {new Date(row.createdAt).toLocaleString()}
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={4} align="center">
                          No Orders Available
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </div>
            )}
          </Grid>

          <Box
            sx={{
              display: "flex",
              alignItems: "flex-end",
              flexDirection: "row",
              m: 1,
              bgcolor: "background.paper",
              borderRadius: 1,
            }}
          >
            <Box>
              <span style={{ marginRight: "10px" }}>Total Paid</span>
              <TextField value={totals.totalPaid} variant="filled" disabled />
            </Box>

            <Box>
              <span style={{ marginRight: "10px" }}>Total Unpaid</span>
              <TextField value={totals.totalUnpaid} variant="filled" disabled />
            </Box>

            <Box
              onClick={() => {
                setOpenPopup(true);
              }}
              component="span"
              sx={{
                display: "inline-block",
                marginLeft: "40px",
                color: "primary.main",
                fontWeight: "bold",
                cursor: "pointer",
                "&:hover": {
                  textDecoration: "underline",
                  color: "primary.dark",
                },
              }}
            >
              See more
            </Box>
          </Box>
        </CardContent>
      </Card>
      <Popup
        title="Customer Orders"
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
      >
        <CustomerOrderPage orders={orders} />
      </Popup>
    </>
  );
};

export default CustomerOrder;
